const API_BASE = process.env.REACT_APP_API_URI;

export const API_ROUTES = {
  BASE: API_BASE,
  SID: API_BASE + "/sid",
};
